/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import '../../scss/custom.scss';
import {
  DataTableSkeleton,
  Pagination,
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
} from 'carbon-components-react';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { getError, apioperation, entitiesLabels } from '../../helpers/Constants';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEnabled } from '../../helpers/authorization/Policies';
import PageBreadCrumb, { StatusTag } from '../../helpers/PageBreadCrumb';
import AuditRepository from '../../helpers/api/AuditRepository';
import { NoRecordsPlaceholder } from '../../helpers/jsonschemaform/DataTableExtention';

export default class DeletedAudit extends Component {
  constructor(props) {
    super(props);

    this.repository = new AuditRepository();
    this.handleChangePaging = this.handleChangePaging.bind(this);

    this.state = {
      items: [],

      currentPage: 1,
      totalAudits: 0,
      pageSize: 10,
      isBack: !!(this.props.history.action === 'POP' || this.props.location.search === '?isBack'),
    };
  }

  async componentDidMount() {
    this.setState({ loading: true });
    const totAudits = await this.getAuditCount();
    const items = await this.getItems();
    this.setState({
      totalAudits: totAudits,
      items,
      loading: false,
    });
  }

  getAuditCount = async () => {
    let totalAudits = 0;
    try {
      totalAudits = await this.repository.getDeletedAuditCount();
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, 'loading audits', apioperation.GET)
      );
    }
    return totalAudits;
  };

  getItems = async () => {
    try {
      const skip = (this.state.currentPage - 1) * this.state.pageSize;
      const audits = await this.repository.getDeletedAudits(skip, this.state.pageSize);
      audits.forEach((x) => {
        x.updatedOn = new Date(x.updatedOn).toLocaleDateString();
        if (x.deleteRequest?.requestOn != null)
          x.deleteRequest.requestOn = new Date(x.deleteRequest.requestOn).toLocaleDateString();
      });
      return audits;
    } catch (error) {
      showNotification.error(
        `${entitiesLabels.ERROR}`,
        getError(error, 'loading audits', apioperation.GET)
      );
      return [];
    }
  };

  handleChangePaging = async (page) => {
    await new Promise((resolve) => {
      this.setState({ currentPage: page.page, pageSize: page.pageSize, loading: true }, resolve);
    });

    const items = await this.getItems();
    this.setState(() => ({
      items,
      loading: false,
    }));
  };

  getCellValue = (type, value, id, index) => {
    if (!value) return '';
    if (typeof value === 'object') {
      if (type.header.includes('auditor')) {
        return value.fullName;
      }
      if (type.header.includes('status')) {
        return <StatusTag value={value.planningName} />;
      }
      if (type.header.includes('checkList')) {
        return <StatusTag value={value.status.reportingName} />;
      }

      if (type.header.includes('deleteRequest') && index === 8) {
        return value.userRequestFrom;
      }

      if (type.header.includes('deleteRequest') && index === 9) {
        return value.requestOn;
      }

      if (type.header.includes('deleteRequest') && index === 10) {
        //RITM0946162
        // return value.reasonForChange;
        return (value.auditCancellationReason === null ? value.reasonForChange : value.auditCancellationReason);
        //End
      }

      if (value instanceof Array) {
        return value.map((elem) => elem.name).join(', ');
      }
      return value.name;
    }
    if (type.header.includes('Month')) {
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const monthToString = (monthNumber) => months[monthNumber - 1] || '';
      return monthToString(value);
    }
    return value;
  };

  render() {
    const paginationProps = () => ({
      page: this.state.currentPage || 1,
      totalItems: this.state.totalAudits || 0,
      pageSize: this.state.pageSize || 10,
      pageSizes: [5, 10, 20, 30, 40, 50],
      onChange: this.handleChangePaging,
    });
    const headers = [
      {
        key: 'auditCode',
        header: 'Code',
        isSortable: true,
      },
      {
        key: 'referenceMonth',
        header: 'Month',
      },
      {
        key: 'referenceYear',
        header: 'Year',
      },
      {
        key: 'division',
        //RITM0945977
        // header: 'Division',
        header: 'Business Line',
      },
      {
        key: 'status',
        header: 'Program Status',
      },
      {
        key: 'checkList',
        header: 'Report Status',
      },
      {
        key: 'updatedOn',
        header: 'Deleted On',
        type: 'datetime',
      },
      {
        key: 'updatedBy',
        header: 'Deleted By',
      },
      {
        key: 'deleteRequest',
        header: 'Request By',
        subkey: 'userRequestFrom',
      },
      {
        key: 'deleteRequest',
        header: 'Request On',
      },
      {
        key: 'deleteRequest',
        header: 'Reasons for change',
      },
    ];
    return (
      <AppContext.Consumer>
        {({ user }) =>
          IsEnabled(user, 'Audit') ? (
            <>
              <PageBreadCrumb
                linkTo="/backoffice"
                linkText="BackOffice"
                titleLeft="Audit Deleted"
              />
              <div className="mainContainer">
                <div className="bx--grid content full-width mainContainer ">
                  {this.state.loading ? (
                    <DataTableSkeleton />
                  ) : (
                    <div>
                      <DataTable
                        useZebraStyles="true"
                        rows={this.state.items}
                        headers={headers}
                        render={({
                          rows,
                          getHeaderProps,
                          getSelectionProps,
                          getBatchActionProps,
                          selectedRows,
                        }) => (
                          <TableContainer>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {headers.map((header) => (
                                    <TableHeader {...getHeaderProps({ header })}>
                                      {header.header}
                                    </TableHeader>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {rows == null || rows.length === 0 ? (
                                  <NoRecordsPlaceholder colSpan={headers.length + 2} />
                                ) : (
                                  rows.map((row) => (
                                    <TableRow key={row.id}>
                                      {row.cells.map((cell, index) => (
                                        <TableCell key={index}>
                                          {this.getCellValue(cell.info, cell.value, row.id, index)}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        )}
                      />
                      <div className="footer-pagination">
                        <Pagination {...paginationProps()} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : null
        }
      </AppContext.Consumer>
    );
  }
}
